import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

const CiteModal = ({
  show,
  onHide,
  selectedFormat,
  setSelectedFormat,
  renderCitation,
}) => {
  const [copied, setCopied] = useState(false);

  const getSanitizedCitation = () => renderCitation().replace(/<\/?em>/g, "");

  const handleCopy = () => {
    navigator.clipboard.writeText(getSanitizedCitation());
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Modal
      show={show}
      size="md"
      onHide={onHide}
      centered
      dialogClassName="modern-cite-modal animate-cite-modal"
      contentClassName="border-0 bg-white p-0"
      backdropClassName="modal-backdrop-blur"
    >
      <div className="p-0 m-0 position-relative rounded-3 shadow-lg cite-modal-root">
        {/* Title & Close */}
        <div className="d-flex justify-content-center align-items-center position-relative pt-4 pb-2 px-4">
          <h3 className="fw-bold text-darkfume mb-0 w-100 text-center cite-modal-title">Alıntıla</h3>
          <button
            type="button"
            className="btn btn-link p-0 position-absolute top-0 end-0 mt-3 me-3 cite-modal-close"
            style={{ fontSize: 24, color: '#b0b0b0' }}
            aria-label="Kapat"
            onClick={onHide}
            tabIndex={0}
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="px-4 pb-4 pt-2 cite-modal-body">
          {/* Format select */}
          <div className="mb-4">
            <label htmlFor="citationFormat" className="form-label text-darkfume small mb-1">Alıntı Formatı</label>
            <div className="position-relative">
              <select
                id="citationFormat"
                className="form-select rounded-3 shadow-sm w-100 pe-5"
                style={{ fontSize: 16, background: '#f6f8fa', border: '1px solid #e5e7eb', appearance: 'none' }}
                value={selectedFormat}
                onChange={(e) => setSelectedFormat(e.target.value)}
              >
                <option value="" disabled>Bir format seçin</option>
                <option value="apa">APA</option>
                <option value="mla">MLA</option>
                <option value="chicago">Chicago</option>
                <option value="vancouver">Vancouver</option>
                <option value="harvard">Harvard</option>
                <option value="ieee">IEEE</option>
                <option value="bibtex">BibTeX</option>
              </select>
              <span
                className="position-absolute top-50 end-0 translate-middle-y me-3 pointer-events-none"
                style={{ fontSize: 18, color: '#b0b0b0' }}
              >
                <i className="fa-solid fa-chevron-down" />
              </span>
            </div>
          </div>
          {/* Citation box and actions only if format is selected */}
          {selectedFormat && (
            <>
              <div className="mb-4 position-relative cite-modal-citationbox">
                <label className="form-label text-darkfume small mb-2">Alıntı</label>
                <div className="bg-citebox rounded-3 shadow-sm p-3 position-relative" style={{ minHeight: 100, background: '#f6f8fa', border: '1px solid #e5e7eb' }}>
                  <pre className="m-0 text-darkfume cite-modal-pre" style={{ background: 'none', border: 'none', fontFamily: 'inherit', fontSize: '1em', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{getSanitizedCitation()}</pre>
                  <div className="position-absolute top-0 end-0 mt-2 me-2 d-flex gap-1 align-items-center">
                    <button
                      className="btn btn-sm btn-light rounded-circle shadow cite-modal-copy"
                      type="button"
                      title="Kopyala"
                      style={{ zIndex: 2 }}
                      onClick={handleCopy}
                    >
                      {copied ? (
                        <i className="fa-solid fa-check text-success" />
                      ) : (
                        <i className="fa-regular fa-copy" />
                      )}
                    </button>
                    {selectedFormat === 'bibtex' && (
                      <button
                        className="btn btn-sm btn-light rounded-circle shadow cite-modal-download"
                        type="button"
                        title="BibTeX İndir"
                        style={{ zIndex: 2 }}
                        onClick={() => {
                          const element = document.createElement('a');
                          const file = new Blob([getSanitizedCitation()], { type: 'text/plain' });
                          element.href = URL.createObjectURL(file);
                          element.download = 'citation.bib';
                          document.body.appendChild(element);
                          element.click();
                        }}
                      >
                        <i className="fa-solid fa-download" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              {/* Action buttons */}
              <div className="d-flex flex-column gap-2 mt-4">
                <button
                  className="btn btn-primary w-100 rounded-3 py-2 fw-semibold cite-modal-btn"
                  type="button"
                  onClick={handleCopy}
                >
                  {copied ? (
                    <>
                      <i className="fa-solid fa-check me-2 text-success" /> Kopyalandı!
                    </>
                  ) : (
                    <>
                      <i className="fa-regular fa-copy me-2" /> Kopyala
                    </>
                  )}
                </button>
                <button
                  className="btn btn-outline-secondary w-100 rounded-3 py-2 fw-semibold cite-modal-btn"
                  type="button"
                  onClick={onHide}
                >
                  <i className="fa-solid fa-xmark me-2" /> Kapat
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CiteModal;